import { API_ENDPOINTS, buildApiUrl } from "../utils/api-config";
import { getAuthToken } from "./api";
import { fetchAuthSession } from 'aws-amplify/auth';

export const getAllProjects = async (customer_id: string) => {
    try {

        const { idToken, userId } = await getAuthToken();
        const response = await fetch(buildApiUrl(API_ENDPOINTS.CUSTOMER_PROJECTS(customer_id)), {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "user-id": userId,
                Authorization: `Bearer ${idToken}`,
            }
        });
        if (!response.ok) {
            throw new Error("Failed to fetch projects");
        }
        return await response.json();

    } catch (error) {
        console.error("Error fetching projects:", error);
        return [];
    }
}

export const fetchPresidioAreas = async () => {
    // Check if we already have the data in localStorage
    try {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const response = await fetch(buildApiUrl(API_ENDPOINTS.STATIC_PRESIDIO_AREAS), {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${idToken}`
            }
        });

        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
        }

        return await response.json();
    }
    catch (error) {
        console.error("Error fetching projects:", error);
        return [];
    }
}

export const getKeyGoalsForCustomer = async (customer_id: string) => {
    try {
        const session = await fetchAuthSession();
        const idToken = session.tokens?.idToken?.toString();

        const response = await fetch(buildApiUrl(API_ENDPOINTS.GET_CUSTOMER_KEY_GOALS(customer_id)), {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${idToken}`
            }
        });

        if (!response.ok) {
            throw new Error(`API request failed with status ${response.status}`);
        }

        return await response.json();
    }
    catch (error) {
        console.error("Error fetching projects:", error);
        return [];
    }
}


export const createProject = async (customer_id: string, projectData: any) => {
    try {
        const { userId, idToken } = await getAuthToken();

        const response = await fetch(buildApiUrl(API_ENDPOINTS.CUSTOMER_PROJECTS(customer_id)), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'user-id': userId,
                Authorization: `Bearer ${idToken}`
            },
            body: JSON.stringify(projectData),
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Failed to add project: ${response.status} ${response.statusText} - ${errorText}`);
            throw new Error(`Failed to add project: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    }
    catch (error) {
        console.log(error)
    }
}


export const updateProject = async (customer_id: string, project_id:string , projectData: any) => {
    try {
        const { userId, idToken } = await getAuthToken();

        const response = await fetch(buildApiUrl(API_ENDPOINTS.UPDATE_CUSTOMER_PROJECT(customer_id , project_id)), {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'user-id': userId,
                Authorization: `Bearer ${idToken}`
            },
            body: JSON.stringify(projectData),
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Failed to update project: ${response.status} ${response.statusText} - ${errorText}`);
            throw new Error(`Failed to add project: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    }
    catch (error) {
        console.log(error)
    }
}

export const deleteProject = async (customer_id:string , project_id:string) => {
    try {
        const { userId, idToken } = await getAuthToken();
        const response = await fetch(buildApiUrl(API_ENDPOINTS.DELETE_CUSTOMER_PROJECT(customer_id , project_id)), {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'user-id': userId,
                Authorization: `Bearer ${idToken}`
            },
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error(`Failed to update project: ${response.status} ${response.statusText} - ${errorText}`);
            throw new Error(`Failed to add project: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.log(error)
    }
}